import React from 'react';
import { ReactComponent as ChatbotReportsIcon } from "../../../../assets/ChatbotReportsSvgs/ChatbotReportsIcon.svg";
import { ReactComponent as CautionIconChatbotReportsIcon } from "../../../../assets/ChatbotReportsSvgs/CautionResponseChatbotReportsIcon.svg";
import './style.scss';

interface SessionFailureMessageBubbleProps {
    message?: string;
    onRetry?: () => void;
}

const SessionFailureMessageBubble: React.FC<SessionFailureMessageBubbleProps> = ({
    message = 'Unable to start the session. Please try again.',
    onRetry
}) => {
    return (
        <div className="session-failure-message-row">
            {/* <div className="session-failure-ai-avatar">
                <ChatbotReportsIcon />
            </div> */}
            <div className="session-failure-message-bubble">
                <CautionIconChatbotReportsIcon className="session-failure-caution-icon" />
                <span className="session-failure-text">{message}</span>
                {onRetry && (
                    <button
                        type="button"
                        className="session-failure-retry-btn"
                        onClick={onRetry}
                    >
                        Retry
                    </button>
                )}
            </div>
        </div>
    );
};

export default SessionFailureMessageBubble;
